import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postDeleteAccount,
  type PostDeleteAccountParams,
  type PostDeleteAccountResponse,
} from '@services/UsersService';

export type UsePostDeleteAccountParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostDeleteAccountResponse,
    unknown,
    string,
    PostDeleteAccountParams,
    PostDeleteAccountResponse
  >;
};

export const postDeleteAccountMutationKey = 'post-delete-account';

export const usePostDeleteAccount = ({
  mutationOptions,
}: UsePostDeleteAccountParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostDeleteAccountResponse,
    unknown,
    string,
    PostDeleteAccountParams
  >(
    postDeleteAccountMutationKey,
    (_url, { arg }) => postDeleteAccount(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
